<template>
  <div class="login-wrapper">
    <div class="stars-container">
      <div class="star star1"></div>
      <div class="star star2"></div>
      <div class="star star3"></div>
      <div class="star star4"></div>
      <div class="star star5"></div>
      <div class="star star6"></div>
      <div class="star star7"></div>
      <div class="star star8"></div>
      <div class="star star9"></div>
      <div class="star star10"></div>
      <div class="star star11"></div>
      <div class="star star12"></div>
      <div class="star star13"></div>
      <div class="star star14"></div>
      <div class="star star15"></div>
      <div class="star star16"></div>
      <div class="star star17"></div>
      <div class="star star18"></div>
      <div class="star star19"></div>
      <div class="star star20"></div>
      <div class="star star21"></div>
      <div class="star star22"></div>
      <div class="star star23"></div>
      <div class="star star24"></div>
      <div class="star star25"></div>
      <div class="star star26"></div>
      <div class="star star27"></div>
      <div class="star star28"></div>
      <div class="star star29"></div>
      <div class="star star30"></div>
      <div class="star star31"></div>
      <div class="star star32"></div>
      <div class="star star33"></div>
      <div class="star star34"></div>
      <div class="star star35"></div>
      <div class="star star36"></div>
      <div class="star star37"></div>
      <div class="star star38"></div>
      <div class="star star39"></div>
      <div class="star star40"></div>
      <div class="star star41"></div>
      <div class="star star42"></div>
      <div class="star star43"></div>
      <div class="star star44"></div>
      <div class="star star45"></div>
      <div class="star star46"></div>
      <div class="star star47"></div>
      <div class="star star48"></div>
      <div class="star star49"></div>
      <div class="star star50"></div>
    </div>
    <div class="login-container">
      <div class="form-header">
        <div class="logo-container">
          <img src="@/assets/logo.png" alt="Logo" class="logo-image" />
        </div>
        <h2>海康智慧电梯托管监测平台</h2>
        <!-- <p>欢迎回来，请登录您的账号</p> -->
      </div>
      <form @submit.prevent="handleLogin" class="floating-form">
        <div class="input-group">
          <input
            id="username"
            v-model.trim="loginForm.username"
            type="text"
            autocomplete="username"
            @input="validateInput"
            required
          />
          <label for="username">用户名</label>
          <span class="highlight"></span>
        </div>
        <div class="input-group">
          <input
            id="password"
            v-model.trim="loginForm.password"
            :type="showPassword ? 'text' : 'password'"
            autocomplete="current-password"
            @input="validateInput"
            required
          />
          <label for="password">密码</label>
          <span class="highlight"></span>
          <i
            class="password-toggle"
            :class="showPassword ? 'eye-open' : 'eye-close'"
            @click="togglePasswordVisibility"
          ></i>
        </div>
        <div class="remember-forgot">
          <label class="remember-me">
            <input type="checkbox" v-model="rememberMe" />
            <span class="checkmark"></span>
            记住密码
          </label>
          <!-- <a href="#" class="forgot-password">忘记密码?</a> -->
        </div>
        <div class="error-message" v-if="errorMsg">{{ errorMsg }}</div>
        <button type="submit" class="submit-btn" :disabled="!isFormValid || loading">
          <span v-if="!loading">登录</span>
          <span v-else>登录中...</span>
          <i class="arrow-icon"></i>
        </button>
        <!-- <div class="remember-forgot">
          <label class="remember-me">
            <input type="checkbox" v-model="rememberMe" />
            <span class="checkmark"></span>
            记住密码
          </label>
          <a href="#" class="forgot-password">忘记密码?</a>
        </div> -->
        <!-- <div class="form-footer">
                    <span>还没有账号？</span>
                    <a href="/register">立即注册</a>
                </div> -->
      </form>
    </div>
  </div>
</template>

<script>
import { reqLogin } from "@/api/login";

export default {
  name: "Login",
  data() {
    return {
      // 表单数据
      loginForm: {
        username: "",
        password: "",
      },
      errorMsg: "",
      isFormValid: false,
      loading: false,
      rememberMe: false,
      showPassword: false,
    };
  },
  mounted() {
    this.loadSavedCredentials();
    this.validateInput();
  },
  methods: {
    // 输入验证
    validateInput() {
      // 基本验证
      if (this.loginForm.username && this.loginForm.password) {
        this.isFormValid = true;
        if (this.errorMsg) {
          this.errorMsg = "";
        }
      } else {
        this.isFormValid = false;
      }
    },
    // 登录处理
    handleLogin() {
      // 防止XSS攻击
      const xssPattern = /(~|\{|\}|"|'|<|>|\?)/g;
      if (
        xssPattern.test(this.loginForm.username) ||
        xssPattern.test(this.loginForm.password)
      ) {
        this.errorMessage("警告:输入内容包含非法字符");
        return;
      }

      // 清除之前的错误信息并显示加载状态
      this.errorMsg = "";
      this.loading = true;

      try {
        // 对输入进行转义处理
        const safeUsername = encodeURIComponent(this.loginForm.username);
        const safePassword = encodeURIComponent(this.loginForm.password);

        // 实际的登录API调用
        reqLogin({
          username: safeUsername,
          password: safePassword,
        })
          .then((res) => {
            this.loading = false;
            console.log("登录响应:", res.data);

            if (res.code == 1) {
              // 登录成功 - 检查是否有token
              if (res.data && res.data.token) {
                localStorage.setItem("token", res.data.token);
                // 保存登录凭据
                this.saveCredentials();
                this.$message.success("登录成功");
                setTimeout(() => {
                  // 跳转到首页，根据路由配置首页是 '/' 对应 HomeView
                  this.$router.push("/");
                }, 1000);
              } else {
                this.errorMessage("登录失败: 服务器返回数据格式错误");
              }
            } else {
              // 登录失败 - 优先使用服务器返回的错误信息
              const errorMsg = res.message || res.msg || "登录失败! 用户名或密码错误";
              this.errorMessage(errorMsg);
            }
          })
          .catch((error) => {
            // 网络错误处理
            this.loading = false;
            console.error("登录请求失败:", error);
            this.errorMessage("登录失败，网络错误或服务器异常");
          });
      } catch (error) {
        this.loading = false;
        console.error("登录处理异常:", error);
        this.errorMessage("登录失败，系统异常");
      }
    },
    // 加载保存的凭据
    loadSavedCredentials() {
      const savedUsername = localStorage.getItem("saved_username");
      const savedPassword = localStorage.getItem("saved_password");
      const savedRememberMe = localStorage.getItem("remember_me");

      if (savedRememberMe === "true" && savedUsername && savedPassword) {
        this.loginForm.username = savedUsername;
        this.loginForm.password = savedPassword;
        this.rememberMe = true;
        this.validateInput();
      }
    },
    // 保存凭据到本地存储
    saveCredentials() {
      if (this.rememberMe) {
        localStorage.setItem("saved_username", this.loginForm.username);
        localStorage.setItem("saved_password", this.loginForm.password);
        localStorage.setItem("remember_me", "true");
      } else {
        localStorage.removeItem("saved_username");
        localStorage.removeItem("saved_password");
        localStorage.removeItem("remember_me");
      }
    },
    // 切换密码显示/隐藏
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    // 清除保存的凭据
    clearSavedCredentials() {
      localStorage.removeItem("saved_username");
      localStorage.removeItem("saved_password");
      localStorage.removeItem("remember_me");
    },
    // 错误提示
    errorMessage(text) {
      this.errorMsg = text;
      setTimeout(() => {
        this.errorMsg = "";
      }, 3000);
    },
  },
};
</script>

<style scoped>
.login-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    135deg,
    #0a0e27 0%,
    #1a1f3a 25%,
    #2d1b4e 50%,
    #1e3a5f 75%,
    #0f2b3d 100%
  );
  position: relative;
  overflow: visible;
  padding: 20px;
  box-sizing: border-box;
}

.login-wrapper::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      circle at 20% 30%,
      rgba(147, 51, 234, 0.4) 0%,
      transparent 50%
    ),
    radial-gradient(circle at 80% 20%, rgba(59, 130, 246, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 40% 80%, rgba(236, 72, 153, 0.3) 0%, transparent 50%);
  pointer-events: none;
}

.stars-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.star {
  position: absolute;
  width: 3px;
  height: 3px;
  background: rgba(255, 255, 255, 1);
  border-radius: 50%;
  box-shadow: 0 0 4px rgba(255, 255, 255, 0.8);
}

.star1 {
  top: 10%;
  left: 20%;
  animation: twinkle1 2.1s ease-in-out infinite;
}
.star2 {
  top: 20%;
  left: 40%;
  animation: twinkle2 3.3s ease-in-out infinite 0.2s;
}
.star3 {
  top: 30%;
  left: 10%;
  animation: twinkle3 1.8s ease-in-out infinite 0.7s;
}
.star4 {
  top: 40%;
  left: 60%;
  animation: twinkle4 2.7s ease-in-out infinite 1.1s;
}
.star5 {
  top: 50%;
  left: 30%;
  animation: twinkle5 2.4s ease-in-out infinite 0.4s;
}
.star6 {
  top: 60%;
  left: 80%;
  animation: twinkle6 3.1s ease-in-out infinite 0.9s;
}
.star7 {
  top: 70%;
  left: 15%;
  animation: twinkle7 2s ease-in-out infinite 0.3s;
}
.star8 {
  top: 80%;
  left: 50%;
  animation: twinkle8 2.9s ease-in-out infinite 0.6s;
}
.star9 {
  top: 90%;
  left: 25%;
  animation: twinkle9 1.9s ease-in-out infinite 1.3s;
}
.star10 {
  top: 15%;
  left: 70%;
  animation: twinkle10 2.6s ease-in-out infinite 0.1s;
}
.star11 {
  top: 25%;
  left: 85%;
  animation: twinkle11 3.2s ease-in-out infinite 0.8s;
}
.star12 {
  top: 35%;
  left: 45%;
  animation: twinkle12 2.2s ease-in-out infinite 0.5s;
}
.star13 {
  top: 45%;
  left: 75%;
  animation: twinkle13 2.8s ease-in-out infinite 1s;
}
.star14 {
  top: 55%;
  left: 90%;
  animation: twinkle14 1.7s ease-in-out infinite 0.2s;
}
.star15 {
  top: 65%;
  left: 35%;
  animation: twinkle15 3s ease-in-out infinite 0.7s;
}
.star16 {
  top: 75%;
  left: 65%;
  animation: twinkle16 2.3s ease-in-out infinite 0.4s;
}
.star17 {
  top: 85%;
  left: 40%;
  animation: twinkle17 2.5s ease-in-out infinite 0.9s;
}
.star18 {
  top: 95%;
  left: 55%;
  animation: twinkle18 1.6s ease-in-out infinite 0.1s;
}
.star19 {
  top: 5%;
  left: 35%;
  animation: twinkle19 3.4s ease-in-out infinite 0.6s;
}
.star20 {
  top: 95%;
  left: 85%;
  animation: twinkle20 2s ease-in-out infinite 0.3s;
}
.star21 {
  top: 12%;
  left: 15%;
  animation: twinkle21 2.3s ease-in-out infinite 0.4s;
}
.star22 {
  top: 22%;
  left: 55%;
  animation: twinkle22 2.8s ease-in-out infinite 0.8s;
}
.star23 {
  top: 32%;
  left: 25%;
  animation: twinkle23 1.9s ease-in-out infinite 0.2s;
}
.star24 {
  top: 42%;
  left: 85%;
  animation: twinkle24 3.1s ease-in-out infinite 1.2s;
}
.star25 {
  top: 52%;
  left: 45%;
  animation: twinkle25 2.5s ease-in-out infinite 0.6s;
}
.star26 {
  top: 62%;
  left: 95%;
  animation: twinkle26 2.7s ease-in-out infinite 0.9s;
}
.star27 {
  top: 72%;
  left: 35%;
  animation: twinkle27 2.1s ease-in-out infinite 0.3s;
}
.star28 {
  top: 82%;
  left: 75%;
  animation: twinkle28 2.9s ease-in-out infinite 0.7s;
}
.star29 {
  top: 92%;
  left: 15%;
  animation: twinkle29 1.8s ease-in-out infinite 0.1s;
}
.star30 {
  top: 8%;
  left: 65%;
  animation: twinkle30 3.2s ease-in-out infinite 0.5s;
}
.star31 {
  top: 18%;
  left: 95%;
  animation: twinkle31 2.4s ease-in-out infinite 0.8s;
}
.star32 {
  top: 28%;
  left: 35%;
  animation: twinkle32 2.6s ease-in-out infinite 0.2s;
}
.star33 {
  top: 38%;
  left: 55%;
  animation: twinkle33 2s ease-in-out infinite 0.9s;
}
.star34 {
  top: 48%;
  left: 85%;
  animation: twinkle34 3s ease-in-out infinite 0.4s;
}
.star35 {
  top: 58%;
  left: 25%;
  animation: twinkle35 2.2s ease-in-out infinite 0.6s;
}
.star36 {
  top: 68%;
  left: 65%;
  animation: twinkle36 2.8s ease-in-out infinite 0.1s;
}
.star37 {
  top: 78%;
  left: 95%;
  animation: twinkle37 2.3s ease-in-out infinite 0.7s;
}
.star38 {
  top: 88%;
  left: 45%;
  animation: twinkle38 2.5s ease-in-out infinite 0.3s;
}
.star39 {
  top: 98%;
  left: 75%;
  animation: twinkle39 1.7s ease-in-out infinite 0.8s;
}
.star40 {
  top: 3%;
  left: 55%;
  animation: twinkle40 3.3s ease-in-out infinite 0.2s;
}
.star41 {
  top: 13%;
  left: 85%;
  animation: twinkle41 2.1s ease-in-out infinite 0.5s;
}
.star42 {
  top: 23%;
  left: 25%;
  animation: twinkle42 2.7s ease-in-out infinite 0.9s;
}
.star43 {
  top: 33%;
  left: 65%;
  animation: twinkle43 2.4s ease-in-out infinite 0.1s;
}
.star44 {
  top: 43%;
  left: 95%;
  animation: twinkle44 2.9s ease-in-out infinite 0.6s;
}
.star45 {
  top: 53%;
  left: 35%;
  animation: twinkle45 2s ease-in-out infinite 0.3s;
}
.star46 {
  top: 63%;
  left: 75%;
  animation: twinkle46 2.6s ease-in-out infinite 0.8s;
}
.star47 {
  top: 73%;
  left: 15%;
  animation: twinkle47 2.3s ease-in-out infinite 0.2s;
}
.star48 {
  top: 83%;
  left: 55%;
  animation: twinkle48 2.8s ease-in-out infinite 0.7s;
}
.star49 {
  top: 93%;
  left: 85%;
  animation: twinkle49 1.9s ease-in-out infinite 0.4s;
}
.star50 {
  top: 7%;
  left: 45%;
  animation: twinkle50 3.1s ease-in-out infinite 0.1s;
}
@keyframes twinkle1 {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle2 {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle3 {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle4 {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle5 {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle6 {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle7 {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle8 {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle9 {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle10 {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle11 {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle12 {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle13 {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle14 {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle15 {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle16 {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle17 {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle18 {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle19 {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle20 {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle21 {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle22 {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle23 {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle24 {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle25 {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle26 {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle27 {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle28 {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle29 {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle30 {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle31 {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle32 {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle33 {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle34 {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle35 {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle36 {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle37 {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle38 {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle39 {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle40 {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle41 {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle42 {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle43 {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle44 {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle45 {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle46 {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle47 {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle48 {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle49 {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
@keyframes twinkle50 {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}

.login-container {
  width: 100%;
  max-width: 480px;
  min-width: 320px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 10;
  margin: auto;
  box-sizing: border-box;
}

.form-header {
  text-align: center;
  margin-bottom: 40px;
}

.form-header h2 {
  color: #3498db;
  font-size: 32px;
  margin-bottom: 10px;
  font-weight: 700;
  background: linear-gradient(to right, #3498db, #2980b9);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.form-header p {
  color: #4a5568;
  font-size: 16px;
}

.logo-container {
  text-align: center;
  margin-bottom: 20px;
}

.logo-image {
  width: 260px;
  height: auto;
  object-fit: contain;
}

.floating-form {
  width: 100%;
  box-sizing: border-box;
}

.floating-form .input-group {
  position: relative;
  margin-bottom: 30px;
  width: 100%;
  box-sizing: border-box;
}

.input-group input {
  width: 100%;
  padding: 15px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  font-size: 16px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.9);
  box-sizing: border-box;
  backdrop-filter: blur(5px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.input-group input:focus {
  border-color: #3498db;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
  outline: none;
}

.input-group input:valid {
  border-color: #27ae60;
  background: rgba(255, 255, 255, 1);
}

.input-group label {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.95);
  padding: 0 8px;
  color: #95a5a6;
  font-size: 16px;
  transition: all 0.3s ease;
  pointer-events: none;
  border-radius: 4px;
  backdrop-filter: blur(5px);
}

.input-group input:focus + label,
.input-group input:valid + label {
  top: 0;
  font-size: 14px;
  color: #3498db;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.input-group input:focus,
.input-group input:valid {
  border-color: #3498db;
}

.input-group input:focus + label,
.input-group input:valid + label {
  top: 0;
  font-size: 14px;
  color: #3498db;
}

.submit-btn {
  width: 100%;
  padding: 15px;
  background: linear-gradient(to right, #3498db, #2980b9);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-sizing: border-box;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);
}

.arrow-icon {
  border: solid white;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(-45deg);
}

/* 密码显示/隐藏切换按钮 */
.password-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 20px;
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.eye-open:before {
  content: "👁️";
  font-size: 18px;
}

.eye-close:before {
  content: "🙈";
  font-size: 18px;
}

/* 记住密码和忘记密码区域 */
.remember-forgot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-size: 14px;
}

.remember-me {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #4a5568;
  position: relative;
}

.remember-me input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: relative;
  height: 18px;
  width: 18px;
  background-color: #eee;
  border: 2px solid #ddd;
  border-radius: 4px;
  margin-right: 8px;
  transition: all 0.3s ease;
}

.remember-me:hover input ~ .checkmark {
  background-color: #ccc;
}

.remember-me input:checked ~ .checkmark {
  background-color: #3498db;
  border-color: #3498db;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.remember-me input:checked ~ .checkmark:after {
  display: block;
}

.remember-me .checkmark:after {
  left: 5px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.forgot-password {
  color: #3498db;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.forgot-password:hover {
  color: #2980b9;
  text-decoration: underline;
}

.form-footer {
  text-align: center;
  margin-top: 20px;
  color: #95a5a6;
}

.form-footer a {
  color: #3498db;
  text-decoration: none;
  margin-left: 5px;
  font-weight: 600;
}

.form-footer a:hover {
  text-decoration: underline;
}

.error-message {
  color: #f56c6c;
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;
}

@media (max-width: 480px) {
  .login-wrapper {
    padding: 10px;
  }

  .login-container {
    padding: 30px 20px;
    margin: 10px;
    width: calc(100% - 20px);
  }

  .form-header h2 {
    font-size: 24px;
  }

  .logo-image {
    width: 160px;
    height: auto;
  }

  .input-group input {
    padding: 12px;
  }
}

@media (max-width: 768px) {
  .login-wrapper {
    padding: 15px;
  }

  .login-container {
    max-width: 400px;
    padding: 35px 30px;
    min-width: 300px;
  }

  .form-header h2 {
    font-size: 28px;
  }

  .form-header p {
    font-size: 14px;
  }

  .logo-image {
    width: 200px;
    height: auto;
  }
}

@media (max-width: 480px) {
  .login-wrapper {
    padding: 10px;
  }

  .login-container {
    padding: 30px 20px;
    min-width: 280px;
    margin: 10px;
  }

  .form-header h2 {
    font-size: 24px;
  }

  .form-header p {
    font-size: 14px;
  }

  .logo-image {
    width: 160px;
    height: auto;
  }

  .input-group input {
    padding: 12px;
    font-size: 14px;
  }

  .input-group label {
    font-size: 14px;
  }

  .submit-btn {
    padding: 12px;
    font-size: 16px;
  }
}

@media (max-width: 320px) {
  .login-wrapper {
    padding: 5px;
  }

  .login-container {
    padding: 20px 15px;
    min-width: 250px;
    margin: 5px;
  }

  .form-header h2 {
    font-size: 20px;
  }

  .logo-image {
    width: 120px;
    height: auto;
  }

  .input-group {
    margin-bottom: 20px;
  }
}

@media (max-height: 600px) {
  .login-wrapper {
    padding: 10px;
  }

  .login-container {
    padding: 25px 30px;
  }

  .form-header {
    margin-bottom: 25px;
  }

  .form-header h2 {
    font-size: 24px;
    margin-bottom: 5px;
  }

  .logo-image {
    width: 120px;
    height: auto;
  }

  .floating-form .input-group {
    margin-bottom: 20px;
  }
}
</style>
